import { Box } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'

const FadeInBox = ({ children }: { children: React.ReactNode }) => {
  return (
    <AnimatePresence>
      <Box.Motion
        width="full"
        initial={{
          opacity: 0,
          translateY: 40,
        }}
        animate={{
          opacity: 1,
          translateY: 0,
        }}
        transition={{
          type: 'spring',
          duration: 1.2,
        }}
      >
        {children}
      </Box.Motion>
    </AnimatePresence>
  )
}

export default FadeInBox
